import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=b3e64bdc&scoped=true"
import script from "./Captcha.vue?vue&type=script&setup=true&lang=js"
export * from "./Captcha.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=b3e64bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e64bdc",
  null
  
)

export default component.exports